import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Button } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderShareDoneButton = (props: Props) => {
  const { onPress } = props;

  return (
    <Button palette="kale" size="large-wide" onPress={onPress}>
      <FormattedMessage {...messages.label} />
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Done',
    description: 'Group Order Share | Modal | Done CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onPress: () => void;
};
